import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { createContext } from '@costar-ui/utils';

var _createContext = createContext({
    strict: false,
    name: 'Popover Context'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  PopoverContextProvider = _createContext2[0],
  usePopoverContext = _createContext2[1];

// private context should only be consumed by within a popover component hierarchy only.
// not to be confused with react-aria-components PopoverContext
var PopoverContextProvider$1 = PopoverContextProvider;

export { PopoverContextProvider$1 as default, usePopoverContext };
//# sourceMappingURL=popover-context.esm.js.map
